import { MODULES } from "./modulesConfig";

const norm = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

// Destinos principales (suites premium y páginas dedicadas).
export const NAV = [
  { label: "OMNIA Hub", link: "/os", tags: "inicio hub tablero dashboard" },
  { label: "CRM", link: "/os/crm", tags: "crm leads ventas contactos clientes" },
  { label: "Finanzas", link: "/os/finance", tags: "finanzas facturas pagos cobrar" },
  { label: "Contabilidad", link: "/os/contabilidad", tags: "contabilidad contador polizas" },
  { label: "Calendario", link: "/os/calendario", tags: "calendario agenda eventos" },
  { label: "Personas", link: "/os/personas", tags: "personas directorio empleados" },
  { label: "Core HR", link: "/os/core-hr", tags: "recursos humanos rh nomina empleados" },
  { label: "TAGMA Studio", link: "/os/tagma", tags: "tagma publicidad campanas marketing" },
  { label: "GOÛT Studio", link: "/os/gout", tags: "gout diseno inmobiliario" },
  { label: "AURA Commerce", link: "/os/aura", tags: "aura tienda ecommerce productos" },
  { label: "Documents Hub", link: "/os/sheets", tags: "google sheets hojas de calculo excel datos informes documentos pdf archivos" },
  { label: "OMNIA Correctivos", link: "/os/correctivos", tags: "correctivos planillas solapas direcciones nodos peso control general moviles referencias" },
  { label: "OMNIA Tickets", link: "/os/control-tickets", tags: "tickets completados correctivos ponderado productividad tecnicos operadores facturar" },
  { label: "Flotilla", link: "/os/flotilla", tags: "flotilla vehiculos autos strix gps rastreo unidades" },
  { label: "VETTA Factory", link: "/os/vetta", tags: "vetta producto fabrica" },
  { label: "Talent", link: "/os/talent", tags: "talento" },
  { label: "Performance", link: "/os/performance", tags: "desempeno evaluaciones" },
  { label: "Learning", link: "/os/learning", tags: "capacitacion cursos academy" },
  { label: "Payroll", link: "/os/payroll", tags: "nomina payroll" },
  { label: "Social", link: "/os/social", tags: "social muro publicaciones" },
  { label: "Social Connect", link: "/os/social-connect", tags: "redes sociales linkedin facebook publicar vincular conectar" },
  { label: "Announcements", link: "/os/announcements", tags: "comunicados avisos" },
  { label: "Digital Signature", link: "/os/sign", tags: "firma documentos" },
  { label: "Administración de usuarios", link: "/os/admin", tags: "admin usuarios roles" },
];

const APPS = Object.entries(MODULES).map(([key, cfg]) => ({
  key, title: cfg.title, record: cfg.record, personal: !!cfg.personal,
  hay: norm(`${cfg.title} ${cfg.record} ${cfg.desc} ${key}`),
}));

const NAV_IDX = NAV.map((n) => ({ ...n, hay: norm(`${n.label} ${n.tags}`) }));

// Sugeridos al abrir el paletta (sin texto).
export const SUGGESTED = [
  { label: "Ir al Hub", link: "/os" },
  { label: "Crear: Tarea", sub: "OMNIA Tasks", link: "/os/mod/tasks?new=1" },
  { label: "Crear: Reunión", sub: "OMNIA Meetings", link: "/os/mod/meetings?new=1" },
  { label: "CRM", link: "/os/crm" },
  { label: "Finanzas", link: "/os/finance" },
];

// Devuelve { navs, actions, apps } coincidentes con el texto q.
export function buildCommands(q) {
  const nq = norm(q);
  if (nq.length < 1) return { navs: [], actions: [], apps: [] };
  const matchApps = APPS.filter((a) => a.hay.includes(nq));
  const navs = NAV_IDX.filter((n) => n.hay.includes(nq)).slice(0, 5);
  const actions = matchApps.slice(0, 4).map((a) => ({
    label: `Crear: ${a.record}`, sub: a.title, link: `/os/mod/${a.key}?new=1`, key: `new-${a.key}`,
  }));
  const apps = matchApps.slice(0, 6).map((a) => ({
    label: a.title, link: `/os/mod/${a.key}`, key: `app-${a.key}`,
  }));
  return { navs, actions, apps };
}
